module.exports = __webpack_public_path__ + "static/media/onboarding-1_2x.5bdbfb9b.png";